export const reletionArr = [
  {
    name: '妈妈',
    id: 1,
  },
  {
    name: '爸爸',
    id: 0,
  },
  {
    name: '爷爷',
    id: 2,
  },
  {
    name: '奶奶',
    id: 3,
  },
  {
    name: '外婆',
    id: 4,
  },
  {
    name: '外公',
    id: 5,
  },
  {
    name: '哥哥',
    id: 6,
  },
  {
    name: '姐姐',
    id: 7,
  },
  {
    name: '伯父',
    id: 9,
  },
  {
    name: '伯母',
    id: 10,
  },
  {
    name: '叔叔',
    id: 11,
  },
  {
    name: '婶婶',
    id: 12,
  },
  {
    name: '姑父',
    id: 13,
  },
  {
    name: '姑母',
    id: 14,
  },
  {
    name: '舅舅',
    id: 15,
  },
  {
    name: '舅妈',
    id: 16,
  },
  {
    name: '姨夫',
    id: 17,
  },
  {
    name: '姨妈',
    id: 18,
  },
  {
    name: '嫂嫂',
    id: 19,
  },
  {
    name: '姐夫',
    id: 20,
  },
  {
    name: '其他亲属',
    id: 8,
  },
]
